import Vue from "vue";
import moment from "moment";
import axios from "axios";
let config = null;
var jwtDecode = require("jwt-decode");
config = axios.get("/static/config.json").then(response => {
  return response.data;
});

export const backendAddress = function(url) {
  return config.then(configData => {
    if (url == null) url = "";
    let baseUrl =
      process.env.NODE_ENV !== "production"
        ? configData.URL_DEV // localhost
        : configData.URL_PROD; // server test
    return baseUrl + url;
  });
};

export const captchaKey = function() {
  return config.then(configData => {
    return configData.CAPTCHA_KEY;
  });
};

export const getTokenFromConfig = function() {
  return config.then(configData => {
    return configData.TOKEN;
  });
};

export const displayInfo = function(content) {
  Vue.notify({
    classes: "",
    group: "notify-group",
    title: "",
    type: "bg-info text-white rounded",
    text: content
  });
};

export const displayWarning = function(content) {
  Vue.notify({
    classes: "",
    group: "notify-group",
    title: "",
    type: "bg-warning text-white rounded",
    text: content
  });
};

export const displayErrors = function(error) {
  Vue.notify({
    classes: "",
    group: "notify-group",
    title: "",
    type: "bg-danger text-white rounded",
    text: error.response.data.message
  });
};

export const dateTime = value => {
  if (value) {
    return moment(value).format("DD.MM.YYYY HH:mm:ss");
  }
};

export const fullDisplayTicketNumber = ticketNumber => {
  var result = "";
  var lengtheNumber = ticketNumber.toString().length;

  if (lengtheNumber == 1) {
    result = "00" + ticketNumber;
  } else if (lengtheNumber == 2) {
    result = "0" + ticketNumber;
  } else {
    result = ticketNumber;
  }
  return result;
};

export const formatStringWithPrefix = (number, count, char) => {
  var result = "";
  var lengthNumber = number.toString().length;
  var length = parseInt(count) - lengthNumber;
  for (var i = 0; i < length; i++) {
    result += char.toString();
  }
  result += number.toString();
  return result;
};

export const vueTableOptions = {
  perPage: 8,
  texts: {
    count: " ", //"Showing {from} to {to} of {count} records|{count} records|One record",
    first: "Pierwsza", //"First",
    last: "Ostatnia", //"Last",
    filter: " ", //"Filter:",
    filterPlaceholder: "Szukaj...", //"Search query",
    limit: "Records:",
    page: "Strona", ///"Page:",
    noResults: "Nie znaleziono pasujących pozycji", //"No matching records",
    filterBy: "Filter by {column}",
    loading: "Wczytywanie...", //"Loading...",
    defaultOption: "Select {column}",
    columns: "Kolumny" //"Columns"
  },
  sortIcon: {
    is: "fa-sort",
    base: "fas",
    up: "fa-sort-amount-up",
    down: "fa-sort-amount-down"
  },
  pagination: {
    dropdown: false,
    chunk: 10,
    edge: true,
    align: "center",
    nav: "fixed"
  }
};

export const validationError = function(error) {
  Vue.notify({
    classes: "",
    group: "notify-group",
    title: "",
    type: "bg-danger text-white rounded",
    text: error
  });
};

export const getTokenData = () => {
  if (sessionStorage.getItem("token")) {
    return jwtDecode(sessionStorage.getItem("token"));
  }
  return null;
};
